import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useSelector } from "react-redux";

import { textConstants } from "@/languages/textConstants";

import Fetching from "@/components/Fetching/Fetching";

import { decimalValidateNew, formatMilesDecimalNew, dateToLocale } from "@/services/Utils";
import apiService from "@/services/api.service";

import classes from "./InputExchange.module.scss";

const InputExchange = ({ data, setData }) => {
	const { customer } = useSelector((state) => state.auth.user);

	const exchangeRateTypeMap = {
		sale: "facturación",
		delivery: textConstants[customer.country_id].delivery,
		order: "orden de compra",
	};

	useEffect(() => {
		if (data.date_calculate) {
			handleChangeBillingDate(data.date_calculate, data.exchange_rate_type);
		}
		// eslint-disable-next-line
	}, [data.date_calculate]);

	const handleChangeBillingDate = (value, _type) => {
		setData({
			...data,
			exchange_rate_fetching: true,
		});

		apiService.get("/client/inventories/exchange_rate", { date: value }).then((response) => {
			setData((prevData) => ({
				...prevData,
				exchange_rate: response.exchange_rate,
				exchange_rate_manual: true,
				exchange_rate_fetching: false,
				exchange_rate_calculated: response.exchange_rate,
			}));
		});
	};

	const applyExchangeRates = () => {
		setData({
			...data,
			exchange_rate: data.exchange_rate_calculated,
			exchange_rate_manual: true,
		});
	};

	return (
		<>
			{data.exchange_rate_fetching ? (
				<Fetching topMargin={"0px"} />
			) : (
				<div>
					<Form.Control
						className={classes.inputValue}
						type="text"
						placeholder=""
						onChange={(e) => {
							const value = String(e.target.value).replaceAll(".", "");

							setData({
								...data,
								exchange_rate: value,
								exchange_rate_manual: true,
							});
						}}
						value={data.exchange_rate ? formatMilesDecimalNew(data.exchange_rate) : ""}
						onKeyDown={decimalValidateNew}
						style={{ textAlign: "right" }}
					/>
					{!data.exchange_rate_manual && data.exchange_rate_calculated && data.exchange_rate_calculated !== data.exchange_rate && (
						<small className={classes.exchange_text}>
							<span className={classes.exchange} onClick={() => applyExchangeRates()}>
								Usar {formatMilesDecimalNew(data.exchange_rate_calculated)}
							</span>{" "}
							{` tipo cambio en base a la fecha de ${exchangeRateTypeMap[data.exchange_rate_type] || "tipo desconocido"} ${dateToLocale(
								data.date_calculate,
							)}.`}
						</small>
					)}
				</div>
			)}
		</>
	);
};

export default InputExchange;
